import React from 'react'
import PropTypes from 'prop-types'
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-material.css'
import UUID from 'uuid'
import i18n from 'simple-react-i18n'
import { getDate } from '../../../utils/DateUtil'
import { BOOLEAN, DATE, FUNCTION, NUMBER } from '../../../utils/TypesConstants'
import { getFieldType } from '../../../utils/TypesUtils'
import HtmlRenderer from './HtmlRenderer'
import * as lodash from 'lodash'
import { isEqual } from 'lodash'
import moment from 'moment'
import ActionComponent from '../../ActionComponent'
import AppStore from '../../../store/AppStore'
import SelectionAction from '../../../dashboard/actions/SelectionAction'
import { connect } from 'react-redux'
import DtoSelection from '../../../dashboard/dto/DtoSelection'
import DtoUser from '../../../home/dto/DtoUser'

class AgGridTable extends ActionComponent {

	shouldComponentUpdate(nextProps): boolean {
		return (
			!isEqual(nextProps.type, this.props.type) ||
			!isEqual(nextProps.datas, this.props.datas) ||
			!isEqual(nextProps.cellHeight, this.props.cellHeight)
		)
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.selectedExportSelections.length && !isEqual(nextProps.selectedExportSelections, this.props.selectedExportSelections)) {
			this.setAction([
				this.getExportActions(),
				this.getExportSelectedSelections(nextProps)
			])
		} else {
			this.checkRemoveSelected(nextProps.selectedExportSelections)
			this.setAction([
				this.getExportActions()
			])
		}
	}

	checkRemoveSelected = (selectedExportSelections) => {
		if (!selectedExportSelections.length) {
			if (this.gridApi.getSelectedRows().length) {
				this.gridApi.deselectAll()
			}
		}
	}

	componentWillMount() {
		this.setAction([
			this.getExportActions()
		])
	}

	getExportActions = () => {
		return {
			fn: () => this.exportCsvFunction(this.gridApi),
			icon: 'file_download',
			title: i18n.csvExport
		}
	}
	getExportSelectedSelections = (props) => {
		return {
			fn: () => AppStore.dispatch(SelectionAction.exportSelections(props.user.login, props.selectedExportSelections)),
			icon: 'file_download',
			title: i18n.download
		}
	}
	exportCsvFunction = (agGrid) => {
		const params = {
			skipHeader: false,
			columnGroups: false,
			skipFooters: false,
			skipGroups: true,
			skipPinnedTop: false,
			skipPinnedBottom: false,
			allColumns: true,
			onlySelected: false,
			suppressQuotes: false,
			fileName: 'export_researchs_' + moment().format('YYYYMMDDhhmmss'),
			columnSeparator: ';'
		}
		params.columnKeys = ['isUpdateData', 'title', 'nbTheme', 'nbWatershed', 'nbStation', 'creationDate', 'updateDate', 'lastExecutionDate', 'favoriteFunction']
		params.processCellCallback = function (t) {
			if (t.column.getColDef().field === 'favoriteFunction') {
				return !!t.node.data.favorite
			} else if (t.column.getColDef().parameter === DATE) {
				return getDate(moment(t.value))
			}
			return t.value
		}
		params.processHeaderCallback = function (t) {
			if (t.column.colId === 'isUpdateData') {
				return i18n.dataAvailable
			} else if (t.column.getColDef().field === 'favoriteFunction') {
				return i18n.favorite
			}
			return t.column.getColDef().headerName
		}
		agGrid.exportDataAsCsv(params)
	}

	constructor(props) {
		super(props)
		this.state = {
			key: UUID.v4()
		}
	}

	getDateDefinition = (field) => {
		return Object.assign({}, field, {
			type: ['dateColumn', 'nonEditableColumn'],
			filter: 'agDateColumnFilter',
			valueFormatter: (data) => getDate(data.value),
			width: 100,
			parameter: DATE
		})
	}
	getNumberDefinition = (field) => {
		return Object.assign({}, field, {
			type: ['numericColumn', 'nonEditableColumn'],
			filter: 'agNumberColumnFilter',
			width: 100,
			parameter: NUMBER
		})
	}
	getTextDefinition = (field, withCheckbox = false) => {
		const result = Object.assign({}, field, {
			type: 'nonEditableColumn',
			filter: 'agTextColumnFilter'
		})
		if (withCheckbox) {
			return Object.assign({}, result, {
				cellRenderer: 'agGroupCellRenderer',
				cellRendererParams: { checkbox: true }
			})
		}
		return result
	}
	getCellColor = (field) => {
		return Object.assign({}, field, {
			width: 5,
			cellClass: function (params) {
				return (params.value ? ['updateColorBackground', 'padding-right-10', 'padding-left-0'] : ['padding-right-10', 'padding-left-0'])
			},
			cellRenderer: function () {
				return ''
			}
		})
	}
	getFunctionDefinition = (field) => {
		return Object.assign({}, field, {
			filter: true,
			suppressMenu: true,
			sortable: true,
			suppressCellSelection: true,
			resizable: false,
			enableStatusBar: false,
			suppressPadding: true,
			width: 50,
			maxWidth: 50,
			minWidth: 50,
			cellRenderer: 'htmlRenderer',
			headerName: '',
			cellClass: ['no-padding']
		})
	}

	getDefaultInitialization = (header) => {
		return {
			field: header,
			headerName: i18n[header],
			cellStyle: function () {
				return {
					fontSize: '18px'
				}
			}
		}
	}

	getHeaders = () => {
		return this.props.type.headers.map((o) => {
			const fieldType = getFieldType(o)
			const field = this.getDefaultInitialization(o)
			switch (fieldType) {
				case DATE :
					return this.getDateDefinition(field)
				case NUMBER:
					return this.getNumberDefinition(field)
				case FUNCTION:
					return this.getFunctionDefinition(field)
				case BOOLEAN:
					return this.getCellColor(field)
				default:
					return this.getTextDefinition(field, o === 'title')
			}
		})
	}
	getCellHeight = () => {
		return this.props.cellHeight
	}

	onGridReady = (params) => {
		this.gridApi = params.api
		this.gridApi.sizeColumnsToFit()
		this.gridApi.doLayout()
	}
	onSelectionChanged = () => {
		AppStore.dispatch(SelectionAction.receiveSelectedExportSelection(this.gridApi.getSelectedRows()))
	}

	render() {
		const allTopologiesCopy = lodash.cloneDeep(this.props.datas)
		return (
			<div key={ this.state.key } className='ag-theme-material' id={ this.state.key }>
				<div style={ { height: (this.props.datas.length * this.props.cellHeight) + 70 + 'px' } }>
					<AgGridReact
						columnDefs={ this.getHeaders() }
						rowData={ allTopologiesCopy }
						rowSelection={ 'multiple' }
						getRowHeight={ this.getCellHeight }
						onGridReady={ this.onGridReady }
						animateRows={ true }
						enableSorting={ true }
						enableFilter={ true }
						accentedSort={ true }
						suppressRowClickSelection={ true }
						onSelectionChanged={ this.onSelectionChanged.bind(this) }
						frameworkComponents={ { htmlRenderer: HtmlRenderer } }
					/>
				</div>
			</div>
		)
	}
}

AgGridTable.propTypes = {
	user: PropTypes.instanceOf(DtoUser),
	type: PropTypes.object,
	datas: PropTypes.arrayOf(PropTypes.object),
	cellHeight: PropTypes.number,
	selectedExportSelections: PropTypes.arrayOf(PropTypes.objectOf(DtoSelection))
}
AgGridTable.defaultProps = {
	cellHeight: 40,
	datas: []
}
const mapStateToProps = (store) => {
	return {
		user: store.HomeReducer.user,
		selectedExportSelections: store.SelectionReducer.selectedExportSelections
	}
}
export default connect(mapStateToProps)(AgGridTable)




// WEBPACK FOOTER //
// ./src/components/dataTable/AgGrid/AgGridTable.js